import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { getTypeLabel } from "@/utils/media";

export default function RecommendList({ items }: { items: MediaItem[] }) {
  if (items.length === 0) return null;

  return (
    <div className="space-y-2.5">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex gap-3 p-2 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer"
        >
          <div className="relative w-14 h-20 shrink-0 rounded-md overflow-hidden">
            <img
              src={item.cover}
              alt={`${item.title} 封面`}
              title={`${item.title} 在线观看`}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            <h4 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-400 transition-colors">
              {item.title}
            </h4>
            <p className="text-[11px] text-foreground-600 mt-1">{item.year} · {getTypeLabel(item.type)}</p>
            <p className="text-[11px] text-foreground-600 mt-0.5 line-clamp-1">{item.genres.join(" / ")}</p>
            <span className="flex items-center gap-1 text-[11px] text-accent-500 mt-1">
              <i className="ri-star-fill text-[10px]" />
              {item.rating.toFixed(1)}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}